module.exports = __webpack_public_path__ + "97d79747ffdec9ea30055900b9b3e1ec.jpg";